module.exports = __webpack_public_path__ + "static/media/organization-office-building-notification-red.6e7773c3.svg";